<div class="container" [@timelineAnimation]>
  <h1 class="text-center mb-4 fw-bold" style="color: #8e0e00">
    Order Timeline
  </h1>
  <!-- <div class="d-flex justify-content-end">
    <button
      (click)="goBack()"
      ngbTooltip="Back To Order History"
      class="btn mb-2"
    >
      Back
    </button>
  </div> -->

  <div class="row">
    <div class="col-md-4" *ngFor="let timeline of userTypeDetailsOrder">
      <div class="card mb-4">
        <div class="card-header text-center">
          <h2 class="text-danger">{{ timeline.userType }}</h2>
        </div>
        <div class="card-body">
          <div class="timeline snake-timeline line">
            <!-- Vertical line container (move it to left side) -->
            <div class="timeline-left">
              <div class="timeline-line-container">
                <div class="timeline-line"></div>
                <div class="timeline-icons">
                  <div
                    *ngFor="
                      let status of timeline.statusDetails;
                      let index = index
                    "
                  >
                    <div class="timeline-icon-wrapper">
                      <div class="timeline-icon">
                        <!-- <i class="{{ getIcon(timeline.userType, step.statusCode) }}"></i> -->
                        <i class="{{ status.statusIcon }}"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Content area (on the right) -->
            <div class="timeline-right">
              <div>
                <div
                  class="timeline-item completed"
                  *ngFor="
                    let status of timeline.statusDetails;
                    let index = index
                  "
                >
                  <div class="timeline-content gap-3">
                    <span><i class="{{ status.statusIcon }} desIcon"></i></span>
                    <strong class="timeline-title ms-2">{{
                      status?.statusDescription
                    }}</strong>
                    <div class="d-flex justify-content-end mt-2">
                      <p>{{ status?.updatedDate }}</p>
                      <p class="ms-3">{{ status?.updatedTime }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
